// Liga/desliga os Termos por site (pedido do Gabriel, 15/10/2026): a Onspace tem
// Termos, a Empsis não. REACT_APP_SHOW_TERMS=true (ou 1) no .env mostra a página
// /termos e o "Li e aceito" do cadastro; qualquer outro valor, ou ausente, esconde
// os dois. Mudou o .env, reinicie o front (ou refaça o build).
const flag = String(process.env.REACT_APP_SHOW_TERMS || "").trim().toLowerCase();

const termsEnabled = flag === "true" || flag === "1";

export default termsEnabled;
